import React, { useEffect, useCallback, useMemo, useState } from 'react'
import { Route, Redirect, RouteProps } from 'react-router-dom'
import { pathNames, configAuthRouteUser, KeyNotice } from './router'
import { keyNameSessionStorage, getSessionStorage, removeSessionStorage } from '../utils/sessionStorage'
import jwt from 'jsonwebtoken'
import useStore from '../stores/useStore'
import { QuestionnaireByMeResponse } from '../pages/make-questionnaire/TakeQuestionnaire'
import { observable } from 'mobx'
import { Task, task } from 'mobx-task'
import apiUrl from '../configs/apiUrl'
import { axiosGet } from '../utils/axios'
import { observer } from 'mobx-react-lite'

type ReturnTypeUsePrivateRouteUser = ReturnType<typeof usePrivateRouteUser>
type UsePrivateRouteUser = {} & RouteProps
const usePrivateRouteUser = ({ location }: UsePrivateRouteUser) => {
    const authPathObj = useMemo(() => configAuthRouteUser?.find((route) => route.path === location?.pathname), [
        location,
    ])
    const { notificationMenuStore } = useStore()

    const [state] = useState<{
        getQuestionnaireByMe: Task<[], Promise<QuestionnaireByMeResponse>>
    }>(
        observable({
            getQuestionnaireByMe: task.resolved(async () => {
                const questionnaireByMe = axiosGet<QuestionnaireByMeResponse>({
                    url: apiUrl.getQuestionnaireByMe,
                    authorizationType: 'authorization',
                })
                const { data } = await questionnaireByMe.request
                return data
            }),
        }),
    )

    const setNotificationMenu = useCallback(async () => {
        if (location?.pathname !== pathNames.takeQuestionnaire) {
            const questionnaire = await state.getQuestionnaireByMe()

            notificationMenuStore.setNotificationMenu(KeyNotice.takeQuestionnaire, [
                {
                    key: KeyNotice.takeQuestionnaire,
                    countBadge: questionnaire.todo.length + questionnaire.draft.length,
                },
            ])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location])

    useEffect(() => {
        setNotificationMenu()
    }, [setNotificationMenu])

    return { authPathObj }
}

type PrivateRouteUserViewProps = {} & RouteProps & ReturnTypeUsePrivateRouteUser
let PrivateRouteUserView: React.FC<PrivateRouteUserViewProps> = ({ location, authPathObj, ...rest }) => {
    const accessToken = getSessionStorage(keyNameSessionStorage.accessToken) || ''
    const jwtDecoded = jwt.decode(accessToken, { complete: true }) as {
        payload?: {
            exp?: number
            roles?: string[]
        }
    }

    return (
        <>
            {(() => {
                if (jwtDecoded?.payload?.roles?.[0] === 'USER' && accessToken) {
                    return (
                        <Route
                            path={authPathObj?.path}
                            {...rest}
                            render={(props) => {
                                //@ts-ignore
                                const { component: Component } = authPathObj
                                return <Component {...props} />
                            }}
                        />
                    )
                } else {
                    removeSessionStorage([
                        keyNameSessionStorage.user,
                        keyNameSessionStorage.accessToken,
                        keyNameSessionStorage.refreshToken,
                    ])

                    return <Redirect to={pathNames.signIn} />
                }
            })()}
        </>
    )
}

PrivateRouteUserView = observer(PrivateRouteUserView)

type PrivateRouteUserProps = {} & Omit<PrivateRouteUserViewProps, keyof ReturnTypeUsePrivateRouteUser>
let PrivateRouteUser: React.FC<RouteProps> = ({ ...props }) => {
    const statePrivateRouteUser = usePrivateRouteUser(props)
    return <PrivateRouteUserView {...props} {...statePrivateRouteUser} />
}
PrivateRouteUser = observer(PrivateRouteUser)
export default PrivateRouteUser
